module.exports = __webpack_public_path__ + "static/media/our-cheese.8918c7a5.jpg";